import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Mail,
  MapPin,
  Phone,
  Facebook,
  Twitter,
  Linkedin,
  ChevronDown,
} from "lucide-react";

export default function FooterPage() {
  const [isProductsOpen, setIsProductsOpen] = useState(false);

  const footerLinks = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    {
      name: "All Products",
      dropdown: true,
      subLinks: [
        { name: "Chemicals", path: "/products/chemicals" },
        { name: "Equipment", path: "/products/equipment" },
      ],
    },
    { name: "FAQ", path: "/faqs" },
    { name: "Contact Us", path: "/contact" },
  ];

  // ✅ Instant scroll to top (no smooth animation)
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "auto" }); // "auto" instead of "smooth"
  };

  return (
    <div className="flex flex-col bg-white">
      {/* Footer Section */}
      <footer className="bg-gray-900 text-gray-300 py-12 px-6 md:px-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img
                src="/img/logo.png"
                alt="Torshia Traders Logo"
                className="w-10 h-10 object-contain"
              />
              <h3 className="text-white font-semibold text-lg">
                Torshia Traders
              </h3>
            </div>
            <p className="text-sm leading-relaxed">
              Welcome to Torshia Traders Private Limited, your premier
              destination for comprehensive solutions in laboratory supplies and
              industrial machinery. Based in Rawalpindi Saddar.
            </p>
          </div>

          {/* Quick Links (with dropdown) */}
          <div>
            <h4 className="text-white text-lg mb-3 border-b-2 border-red-600 inline-block">
              Quick Links
            </h4>
            <ul className="space-y-2 mt-3">
              {footerLinks.map((item) =>
                item.dropdown ? (
                  <li key={item.name}>
                    <button
                      onClick={() => setIsProductsOpen(!isProductsOpen)}
                      className="flex items-center gap-1 hover:text-red-500 transition cursor-pointer w-full text-left"
                    >
                      {item.name}
                      <ChevronDown
                        size={16}
                        className={`transition-transform ${
                          isProductsOpen ? "rotate-180" : ""
                        }`}
                      />
                    </button>
                    {isProductsOpen && (
                      <ul className="ml-4 mt-2 space-y-1 text-sm">
                        {item.subLinks.map((sub) => (
                          <li key={sub.name}>
                            <Link
                              to={sub.path}
                              onClick={handleClick}
                              className="hover:text-red-500 transition"
                            >
                              {sub.name}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ) : (
                  <li
                    key={item.name}
                    className="hover:text-red-500 transition cursor-pointer"
                  >
                    <Link to={item.path} onClick={handleClick}>
                      {item.name}
                    </Link>
                  </li>
                )
              )}
            </ul>
          </div>

          {/* Social Links */}
          <div>
            <h4 className="text-white text-lg mb-3 border-b-2 border-red-600 inline-block">
              Social
            </h4>
            <ul className="space-y-3 mt-3">
              <li className="flex items-center gap-2 hover:text-red-500 transition cursor-pointer">
                <Facebook size={18} /> Facebook
              </li>
              <li className="flex items-center gap-2 hover:text-red-500 transition cursor-pointer">
                <Twitter size={18} /> Twitter
              </li>
              <li className="flex items-center gap-2 hover:text-red-500 transition cursor-pointer">
                <Linkedin size={18} /> Linkedin
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white text-lg mb-3 border-b-2 border-red-600 inline-block">
              Contact Us
            </h4>
            <ul className="space-y-3 mt-3 text-sm">
              <li className="flex items-start gap-2">
                <MapPin size={18} className="mt-1" />
                138-B, Mellow Multi Mall MR-2, Gate #2, Block-B, B-17, Islamabad
              </li>
              <li className="flex items-center gap-2">
                <Phone size={18} /> (+92) 321 7830991
              </li>
              <li className="flex items-center gap-2">
                <Mail size={18} /> torshiatraders@gmail.com
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="text-center text-gray-500 text-sm mt-10 border-t border-gray-700 pt-6">
          © {new Date().getFullYear()}{" "}
          <span className="text-white font-medium">
            Torshia Traders Pvt. Ltd.
          </span>{" "}
          All rights reserved.
        </div>
      </footer>
    </div>
  );
}
